"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _index = require("../index");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var CheckIn = function CheckIn(props) {
  var id = props.id,
    _props$width = props.width,
    width = _props$width === void 0 ? 24 : _props$width,
    _props$height = props.height,
    height = _props$height === void 0 ? 20 : _props$height,
    _props$color = props.color,
    color = _props$color === void 0 ? '#6F6F6F' : _props$color,
    _props$title = props.title,
    title = _props$title === void 0 ? 'check in' : _props$title,
    _props$description = props.description,
    description = _props$description === void 0 ? 'check in' : _props$description;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 24 20"
  }, /*#__PURE__*/_react["default"].createElement("title", null, title), /*#__PURE__*/_react["default"].createElement("desc", null, description), /*#__PURE__*/_react["default"].createElement("g", {
    id: "UI-Design_Final",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "Tenant-User_My-Access_PAP's",
    transform: "translate(-1122.000000, -544.000000)",
    fill: color,
    fillRule: "nonzero"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "Check-In",
    transform: "translate(1133.500000, 554.500000) scale(-1, 1) translate(-1133.500000, -554.500000) translate(1122.000000, 545.000000)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M21.3178587,8.29400318 L10.4903225,8.29400318 L13.554936,5.24522269 C13.8392826,4.95560995 13.8337943,4.49151489 13.5426775,4.20863734 C13.2515608,3.92575979 12.7850556,3.93121973 12.5007089,4.22083245 L8.21025001,8.51351537 C7.92991666,8.79803502 7.92991666,9.25338598 8.21025001,9.53790562 L12.5007089,13.8305885 C12.7850556,14.1202013 13.2515608,14.1256612 13.5426775,13.8427836 C13.8337943,13.5599061 13.8392826,13.095811 13.554936,12.8061983 L10.4903225,9.75741781 L21.3178587,9.75741781 C21.7240681,9.75741781 22.053366,9.42982129 22.053366,9.0257105 C22.053366,8.6215997 21.7240681,8.29400318 21.3178587,8.29400318 Z",
    id: "Shape-Copy",
    transform: "translate(15.026683, 9.025710) rotate(-360.000000) translate(-15.026683, -9.025710) "
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M18.8450213,4.96191406 C18.8450213,5.37612762 18.5092349,5.71191406 18.0950213,5.71191406 C17.6808078,5.71191406 17.3450213,5.37612762 17.3450213,4.96191406 L17.3450288,2.98981051 C17.3517976,1.4760253 16.7055581,0.809283168 15.1938983,0.75 L3.1143983,0.749835344 C1.44764249,0.784766781 0.75,1.45865247 0.75,2.99316406 L0.749773543,14.9808384 C0.792264677,16.7095508 1.50141914,17.4397034 3.09868345,17.4397034 L15.1938983,17.4397034 C16.6971742,17.4397034 17.3451536,16.7271047 17.3450213,14.9992676 L17.3450213,13.1005859 C17.3450213,12.6863724 17.6808078,12.3505859 18.0950213,12.3505859 C18.5092349,12.3505859 18.8450213,12.6863724 18.8450213,13.1005859 L18.8450213,14.9992102 C18.8452146,17.5253449 17.5591119,18.9397034 15.1938983,18.9397034 L3.09868345,18.9397034 C0.668929524,18.9397034 -0.687704977,17.5428988 -0.75,14.9992676 L-0.75,2.99316406 C-0.75,0.623378783 0.618146478,-0.69817824 3.09868345,-0.75 L15.2230087,-0.749434844 C17.5675727,-0.658364658 18.8554152,0.670335915 18.8450213,2.99316406 L18.8450213,4.96191406 Z",
    id: "Path-2-Copy"
  })))));
};
CheckIn.propTypes = _index.iconProps;
var _default = CheckIn;
exports["default"] = _default;